import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { Assessment } from '../entities/Assessment'

@InputType()
export class CloneAssessmentArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => String, { nullable: true })
  name?: string
}

export interface ICloneAssessment extends IAction<Assessment, CloneAssessmentArgs> {}
